import React from "react";
import { Button, Drawer, Form, Input, FormInstance } from "antd";
import { HelixTemplate } from "./Helix";

type Handlers = {
  closeEditDrawer: () => void;
  onFinishEditing: (values: any) => void;
};

type Editing = {
  editingRow?: HelixTemplate | null;
};

type Values = {
  editingForm: FormInstance;
  visibleEditDrawer: boolean;
  editing: Editing | null;
  editFormRef: React.RefObject<FormInstance>;
  helixTemplates: HelixTemplate[];
};

type Props = {
  handlers: Handlers;
  values: Values;
};

const EditHelixTemplate: React.FC<Props> = ({ handlers, values }) => {
  const { closeEditDrawer, onFinishEditing } = handlers;
  const { editingForm, visibleEditDrawer, editing, editFormRef, helixTemplates } = values;

  const editingRow = editing?.editingRow;

  return (
    <Drawer
      title="Edit Helix Template"
      placement="right"
      onClose={closeEditDrawer}
      open={visibleEditDrawer}
      width={500}
      closable={true}
      className="manage-pages-drawer"
      forceRender
    >
      {editingRow && (
        <Form
          form={editingForm}
          layout="vertical"
          onFinish={onFinishEditing}
          name="editProductForm"
          ref={editFormRef}
          initialValues={{
            idValue: editingRow.id,
            helixIdValue: editingRow.helixId,
            nameValue: editingRow.name,
            descValue: editingRow.description,
          }}
        >
          <Form.Item
            name="nameValue"
            label="Name"
            rules={[{ required: true, message: "Please enter Helix Template name" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="helixIdValue"
            label="Helix Template ID"
            rules={[
              { required: true, message: "Please enter Helix Template ID" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const idValue = getFieldValue("idValue");
                  const helixIdValues = helixTemplates.map((item) => ({
                    id: item._id,
                    helixId: item.helixId,
                  }));

                  const matchedHelixId = helixIdValues.filter(
                    (item) => item.helixId === value && item.id !== idValue
                  );

                  if (matchedHelixId.length === 0) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(
                      new Error(`ID: ${value} already exists, please enter a new id`)
                    );
                  }
                },
              }),
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="descValue"
            label="Description"
            rules={[{ required: true, message: "Please enter Helix a description" }]}
          >
            <Input.TextArea />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Save Template
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default EditHelixTemplate;
